import React from 'react';
import { useSelector } from 'react-redux';
import { getLabels } from 'src/redux/app/selectors';

const useLabel = () => {
  const labels = useSelector(getLabels);

  const getLabel = (labelName, fallback) => labels[labelName] || fallback || labelName;

  return getLabel;
};

export default useLabel;
